import LocalizedStrings from 'localized-strings';

import { RequestsFilterState } from '../../types';

const locales = new LocalizedStrings({
  en: {
    description:
      'This is where you will find the requests made by your employees',
    title: {
      [RequestsFilterState.Pending]: 'No request to process',
      [RequestsFilterState.Processing]: 'No request in processing',
      [RequestsFilterState.Done]: 'No request completed',
    },
  },
  fr: {
    description:
      'C’est ici que vous retrouverez les demandes réalisées par vos employé·es',
    title: {
      [RequestsFilterState.Pending]: 'Aucune demande à traiter',
      [RequestsFilterState.Processing]: 'Aucune demande en traitement',
      [RequestsFilterState.Done]: 'Aucune demande terminées',
    },
  },
} as const);

export default locales;
